import React from 'react';
import styled from 'styled-components';
import { bool, string, func, node } from 'prop-types';
import * as StyledGoal from 'apps/journey/pages/my-journey/components/styled-goal';
import ProgressCircle from 'library/components/progress-circle';
import { BaseStyleguideColors } from 'context/color';
import { darken, lighten, transparentize } from 'library/util/css';

const StyledShareTypeCircle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 200px;
  outline: none;
`;

const ShareTypeCircle = ({ active, title, description, onClick, icon }) => {
  return (
    <StyledShareTypeCircle
      role="checkbox"
      aria-checked={active}
      onClick={onClick}
      active={active}
    >
      <StyledGoal.LogoWrapper active={active}>
        <ProgressCircle
          fillColor={
            active
              ? transparentize(lighten(BaseStyleguideColors.green200, 0.2), 0.2)
              : 'transparent'
          }
          width={80}
          height={80}
          strokeColor={lighten(BaseStyleguideColors.green200, 0.7)}
          progressStrokeColor={darken(BaseStyleguideColors.green200, 0.2)}
          className="goalCircle"
          cursor="pointer"
        >
          {active && (
            <StyledGoal.StyledCheckSvg display="flex" justifyContent="center">
              {icon}
            </StyledGoal.StyledCheckSvg>
          )}
        </ProgressCircle>
      </StyledGoal.LogoWrapper>
      <StyledGoal.Details>
        <h3>{title}</h3>
        <p>{description}</p>
      </StyledGoal.Details>
    </StyledShareTypeCircle>
  );
};

ShareTypeCircle.propTypes = {
  active: bool,
  title: string,
  description: string,
  onClick: func,
  icon: node,
};

export default ShareTypeCircle;
